/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Fri May 06 2022
*  File : SDKServer.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { ServerSdk7 } from "@api-commons/sdk/ServerSdk7.js";

export const SdkServer = (cfg: PropertyConfig) => {
    const srv = new ServerSdk7(cfg);
    return srv;
};